export const SYSTEM_ROOT_ID = '__SYSTEM__ROOT__'
